import {
  PageWrapper,
  STATUSPAGE,
  SummaryOfTerminationTerms,
  TceSummaryBySituation,
} from '@repo/ui';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { TceFilters } from '../components/TceFilters';
import { useTceSummary } from '../hooks/useTceSummary';

export const TceSummary = () => {
  const location = useLocation();
  const initialFilters = location.state?.filters ? location.state.filters : {};

  const {
    requestGetAllGroupsUser,
    requestGetAllCoursesUser,
    requestTceSummaryBySituation,
    requestGetInternshipLocations,
    requestGetAllOrganizationsUser,
    requestSummaryOfTerminationTerms,
    validation,
    groupsUser,
    coursesUser,
    tceCountRows,
    organizationsUser,
    tceSummaryBySituation,
    terminationTermCountRows,
    summaryOfTerminationTerms,
    shouldRenderTceCountTable,
    loadingReportSelectCourse,
    loadingInternshipLocations,
    loadingReportSelectOrganization,
    internshipLocationsSelectOptions,
    shouldRenderTerminationTermCountTable,
  } = useTceSummary(initialFilters);

  useEffect(() => {
    const courseValues =
      initialFilters?.course?.map(
        (course: { value: string }) => course.value,
      ) || [];
    const entityValues =
      initialFilters?.entity?.map(
        (entity: { value: string }) => entity.value,
      ) || [];
    const groupValues =
      initialFilters?.group?.map((group: { value: string }) => group.value) ||
      [];
    const localValues =
      initialFilters?.local?.map((local: { value: string }) => local.value) ||
      [];

    const filterParams = {
      courseHashIds: courseValues,
      organizationHashIds: entityValues,
      groups: groupValues.length > 0 ? groupValues : undefined,
      internshipLocations: localValues.length > 0 ? localValues : undefined,
      studentName: initialFilters?.studentName || undefined,
      cpf: initialFilters?.studentCpf || undefined,
    };

    requestSummaryOfTerminationTerms(filterParams);
    requestTceSummaryBySituation(filterParams);

    if (groupsUser.length === 0) {
      requestGetAllGroupsUser();
    }
    if (coursesUser.length === 0) {
      requestGetAllCoursesUser();
    }
    if (organizationsUser.length === 0) {
      requestGetAllOrganizationsUser();
    }

    if (
      courseValues.length > 0 ||
      entityValues.length > 0 ||
      groupValues.length > 0
    ) {
      requestGetInternshipLocations();
    }
  }, []);

  useEffect(() => {
    const hasFilters =
      validation.values.entity.length > 0 ||
      validation.values.course.length > 0 ||
      validation.values.group.length > 0;

    if (hasFilters) {
      requestGetInternshipLocations();
    }
  }, [
    validation.values.entity,
    validation.values.course,
    validation.values.group,
  ]);

  // Constants
  const noDataSummaryConfig = {
    noDataTitle: 'Nenhum resumo de TCE encontrado',
    noDataDescription:
      'Use os filtros acima para pesquisar resumos de TCE por organização ou curso.',
  };

  const noDataTerminationTermConfig = {
    noDataTitle: 'Nenhum resumo de Termo de Rescisão encontrado',
    noDataDescription:
      'Use os filtros acima para pesquisar resumos de Termo de Rescisão por organização ou curso.',
  };

  return (
    <PageWrapper title="TCE">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold">TCE</h4>
        </div>
      </div>

      <TceFilters
        groupsUser={groupsUser}
        validation={validation}
        coursesUser={coursesUser}
        organizationsUser={organizationsUser}
        loadingReportSelectCourse={loadingReportSelectCourse}
        loadingInternshipLocations={loadingInternshipLocations}
        loadingReportSelectOrganization={loadingReportSelectOrganization}
        internshipLocationsSelectOptions={internshipLocationsSelectOptions}
        isSearching={
          tceSummaryBySituation.status === STATUSPAGE.LOADING ||
          summaryOfTerminationTerms.status === STATUSPAGE.LOADING
        }
      />

      <TceSummaryBySituation
        tceCountRows={tceCountRows}
        loading={tceSummaryBySituation.status}
        noDataTitle={noDataSummaryConfig.noDataTitle}
        shouldRenderTceCountTable={shouldRenderTceCountTable}
        noDataDescription={noDataSummaryConfig.noDataDescription}
      />

      <SummaryOfTerminationTerms
        loading={summaryOfTerminationTerms.status}
        terminationTermCountRows={terminationTermCountRows}
        noDataTitle={noDataTerminationTermConfig.noDataTitle}
        noDataDescription={noDataTerminationTermConfig.noDataDescription}
        shouldRenderTerminationTermCountTable={
          shouldRenderTerminationTermCountTable
        }
      />
    </PageWrapper>
  );
};
